import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const oneYearOldPlunk: BlogMetaData = {
  title: '1〜2歳のイタズラ対応｜モンテッソーリ教育のプロが解説',
  description:
    'ティッシュをいっぱい出したり、机の上のものを下に落としたり。１歳から２歳前後の子どものイタズラにイライラしてしまうことはありませんか？実はこれらのイタズラは子供の成長に必要な行為です。イタズラに対する接し方や対策を解説します。',
  thumbnailUrl: '/img/blog-2-year-old-prank.webp',
  filePath: buildBlogFilePath('2-year-old-prank'),
  category: BLOG_CATEGORY.PARENTING,
};
